module.exports = __webpack_public_path__ + "static/media/covid19-impact.a15514f1.gif";